import type { IconProps } from '@components/icons';

import type { JobState } from 'types/jobs';

import { JOB_STATE_ICONS } from './job-state';

/** The card icons, so a tab shows the same glyph as the cards it lists. */
export const JOB_TAB_ICONS: Record<JobState, (props: IconProps) => JSX.Element> = {
  published: JOB_STATE_ICONS.published.Icon,
  drafts: JOB_STATE_ICONS.draft.Icon,
  expired: JOB_STATE_ICONS.expired.Icon,
  archived: JOB_STATE_ICONS.archived.Icon,
};
